export default "__VITE_ASSET__746105d2__"